import { IncomingMessage } from 'http';

import getConfig from 'next/config';

import { fechFromBPartsApi } from '../utils';

const { serverRuntimeConfig } = getConfig();

const fetchSimilarVehicles = async (
  {
    locale,
    vehicle,
  }: {
    locale: string;
    vehicle: string;
  },
  req?: IncomingMessage
) => {
  const data = await fechFromBPartsApi(
    `/${locale}/shop/vehicles/similar/${encodeURI(vehicle)}`,
    {
      credentials: 'include',
      headers: req ? new Headers(req.headers as HeadersInit) : undefined,
    },
      );

  return data.json();
};

export default fetchSimilarVehicles;
